import { render, staticRenderFns } from "./PacsTable.vue?vue&type=template&id=5157e236&scoped=true"
import script from "./PacsTable.vue?vue&type=script&lang=js"
export * from "./PacsTable.vue?vue&type=script&lang=js"
import style0 from "./PacsTable.vue?vue&type=style&index=0&id=5157e236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5157e236",
  null
  
)

export default component.exports